
import styles from './index.module.scss'
import Utils from '@utils/utils'
import { IMAGE_TYPE, DISPLAY_TYPE } from '@utils/CONST'
import { useMemo } from "react"
import { MoreOutlined } from '@ant-design/icons';
import Iconfont from '@utils/Iconfont';
import API from '@api/api'
import { Popover, message } from 'antd'
import PSAIModal from '@PSAIComponents/PSAIModal'

const TopBtnGroups = (props) => {
    const { showTopBtns, taskId, item, displayType } = props


    const isShowGenerate = useMemo(() => {
        return displayType == DISPLAY_TYPE.GENERATE
    }, [displayType])

    const collectClick = (e) => {
        props.toBookmark(e)
    }

    const hdCost = useMemo(() => {
        if (props.imageType == IMAGE_TYPE.COMMODITY_VIDEO || props.imageType == IMAGE_TYPE.MODEL_VIDEO || props.imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) return 40
        return 5
    }, [props.imageType])

    const disabledHD = useMemo(() => { //高清中
        return item?.results?.[0]?.hdStatus == 'started' ||
            item?.results?.[0]?.hdStatus == 'pending' ||
            item?.results?.[0]?.hdStatus == 'processing'
    }, [item])

    const haveHD = useMemo(() => { // 已经高清
        return item?.results?.[0]?.hdImage
    }, [item])

    const isSmartBeauty = props.imageType == IMAGE_TYPE.AI_SMART_BEAUTY

    const DownloadMenuContent = (
        <div
            className={styles.DownloadMenu}
            onMouseEnter={() => props.setShowTopBtns(true)}
            onMouseLeave={() => props.setShowTopBtns(false)}
        >
            {
                (
                    item?.results?.[0]?.payed &&
                    item.imageType != IMAGE_TYPE.AI_IMAGE_EXTRACTION &&
                    item.imageType != IMAGE_TYPE.REMOVE_INPAINT &&
                    item.imageType != IMAGE_TYPE.AI_BEAUTY &&
                    item.imageType != IMAGE_TYPE.IMAGE_FINER &&
                    item.imageType != IMAGE_TYPE.AI_SMART_BEAUTY &&
                    item.imageType != IMAGE_TYPE.IMAGE_RESIZE &&
                    item.imageType != IMAGE_TYPE.MODEL_VIDEO &&
                    item.imageType != IMAGE_TYPE.IMAGE_TO_VIDEO &&
                    item.imageType != IMAGE_TYPE.GRASS_PLANT &&
                    item.imageType != IMAGE_TYPE.WATERMARK_REMOVE &&
                    item.imageType != IMAGE_TYPE.HAND_FIX) &&
                (!item?.orgData || haveHD) &&
                <div className={styles.MenuItem} onClick={(e) => hdDownloadFuncEmit(e)}>
                    <span>高清下载</span>
                    {
                        !haveHD && <div style={{ display: 'flex', alignItems: 'baseline' }}>
                            <img src={require('@assets/images/arcbean3.png')} />
                            <span>{hdCost}</span>
                        </div>
                    }
                </div>
            }

            <div className={styles.MenuItem} onClick={(e) => commonDownloadFuncEmit(e)}>
                <span>普通下载</span>
            </div>
        </div>
    )

    const commonDownloadFuncEmit = async (e) => {
        e.stopPropagation()
        // const status = Utils.checkFirstDownLoad(() => commonDownloadFunc(e))
        // if (!status) return
        commonDownloadFunc(e)
    }
    const commonDownloadFunc = async (e) => {
        try {
            e.stopPropagation()
            let res = await API.commonDownload({ taskId })
            if (res?.code != 0) throw new Error(res?.message)
            const image = res.data
            Utils.downUrl(image, props.imageType)
            message.success('下载成功');
        } catch (err) {
            message.error(err.message)
        }
    }

    const hdDownloadFuncEmit = async (e) => {
        e.stopPropagation()
        // const status = Utils.checkFirstDownLoad(() => hdDownloadFunc(e))
        // if (!status) return
        hdDownloadFunc(e)
    }

    const hdDownloadFunc = async (e) => {
        try {
            e.stopPropagation()
            if (disabledHD) {
                message.warning('正在高清中！')
                return false
            }
            if (!haveHD) {
                PSAIModal.confirm({
                    title: `下载${props.imageType == IMAGE_TYPE.MODEL_VIDEO || props.imageType == IMAGE_TYPE.IMAGE_TO_VIDEO ? "高清视频" : "高清图"}将扣除您${hdCost}个虹豆`,
                    content: `该${props.imageType == IMAGE_TYPE.MODEL_VIDEO || props.imageType == IMAGE_TYPE.IMAGE_TO_VIDEO ? "视频" : "图片"}生成后进行下载操作无需再次扣点，您确认要下载吗？`,
                    onOk: async () => {
                        await props.doHDv2()
                    }
                })
            } else {
                const res = await API.hdDownload({ taskId })
                if (res?.code != 0) throw new Error(res?.message)
                const image = res.data
                Utils.downUrl(image, props.imageType)
                message.success('下载成功')
            }
        } catch (err) {
            message.error(err.message)
        }
    }

    // 更换模特、背景、复刻
    const handleChangeModel = async (e) => {
        e.stopPropagation()
        props.changeModelOrSenceClick(item, 'model')
    }

    const handleChangeBg = async (e) => {
        e.stopPropagation()
        props.changeModelOrSenceClick(item, 'bg')
    }

    const handleChangeVideo = async (e) => {
        e.stopPropagation()
        props.changeModelOrSenceClick(item, 'video')
    }

    const MoreOutMenuContent = (
        <div
            className={styles.DownloadMenu}
            onMouseEnter={() => props.setShowTopBtns(true)}
            onMouseLeave={() => props.setShowTopBtns(false)}
        >
            {
                !item.orgData && <>
                    {
                        (props.imageType == IMAGE_TYPE.MODEL || props.imageType == IMAGE_TYPE.CLOTHES) &&
                        <div className={styles.MenuItem} onClick={(e) => handleChangeModel(e)}>
                            <Iconfont type="icon-changeModelOutlined" className={styles.Icon} />
                            <span>更换容貌</span>
                        </div>
                    }
                    {
                        (props.imageType == IMAGE_TYPE.MODEL || props.imageType == IMAGE_TYPE.CLOTHES) &&
                        <div className={styles.MenuItem} onClick={(e) => handleChangeBg(e)} >
                            <Iconfont type="icon-changeBkgOutlined" className={styles.Icon} />
                            <span>更换背景</span>
                        </div>
                    }
                    {
                        (props.imageType == IMAGE_TYPE.MODEL_VIDEO) &&
                        <div className={styles.MenuItem} onClick={(e) => handleChangeVideo(e)} >
                            <Iconfont type="icon-changeBkgOutlined" className={styles.Icon} />
                            <span>更换动作</span>
                        </div>
                    }
                    {
                        (props.imageType == IMAGE_TYPE.MODEL) &&
                        <div className={styles.MenuItem} onClick={(e) => props.handleReclipa(e, item)} >
                            <Iconfont type="icon-reuseOutlined" className={styles.Icon} />
                            <span>复用模特/背景</span>
                        </div>
                    }
                </>
            }
            <div className={styles.MenuItem} onClick={(e) => props.toShare(e)}>
                <Iconfont type="icon-shareOutlined" className={styles.Icon} />
                <span>分享</span>
            </div>
            <div className={styles.MenuItem} onClick={(e) => props.deleteClick(e)}>
                <Iconfont type="icon-DeleteOutlined" className={styles.Icon} />
                <span>删除</span>
            </div>
        </div>
    )


    return (
        showTopBtns && <div className={`${styles.TopBtnGroups}`}>
            {
                !item.orgData && <span onClick={(e) => collectClick(e)}>
                    {item.bookmark ? <Iconfont type="icon-StarFilled" style={{ color: '#FFBC3F' }} className={styles.Icon} /> :
                        <Iconfont type="icon-StarOutlined" className={styles.Icon} />}
                </span>
            }
            {
                item?.results?.[0]?.payed && !isSmartBeauty ? <Popover
                    placement="bottomLeft"
                    content={DownloadMenuContent}
                    arrow={false}
                    styles={{ body: { borderRadius: '12px', padding: 0, background: 'transparent', boxShadow: 'none' } }}
                >
                    <span onClick={(e) => e.stopPropagation()}>
                        <Iconfont type="icon-DownloadOutlined" className={styles.Icon} />
                    </span>
                </Popover> :
                    <span onClick={(e) => commonDownloadFuncEmit(e)}>
                        <Iconfont type="icon-DownloadOutlined" className={styles.Icon} />
                    </span>
            }
            {
                isShowGenerate && <span onClick={(e) => props.toShare(e)}>
                    <Iconfont type="icon-shareOutlined" className={styles.Icon} />
                </span>
            }
            {
                isShowGenerate && <span onClick={(e) => props.deleteClick(e)}>
                    <Iconfont type="icon-DeleteOutlined" className={styles.Icon} />
                </span>
            }
            {
                !isShowGenerate &&
                <Popover
                    placement="bottomLeft"
                    content={MoreOutMenuContent}
                    arrow={false}
                    styles={{ body: { borderRadius: '12px', padding: 0, background: 'transparent', boxShadow: 'none' } }}
                >
                    <span onClick={(e) => e.stopPropagation()}>
                        <MoreOutlined className={styles.Icon} />
                    </span>
                </Popover>
            }
        </div>
    )
}

export default TopBtnGroups
